import { FC, ComponentProps } from 'react';

import { i18n as I18n } from 'utils/i18n';

import TimeTable from '../timeTable';
import ClinicalTimes from './clinicalTimes';
import NonClinicalTimes from './nonClinicalTimes';

interface Props {
  bookingSlots?: ComponentProps<typeof ClinicalTimes>['bookingSlots'];
  openingTimes?: ComponentProps<typeof NonClinicalTimes>['openingTimes'];
  clinicalRooms: boolean;
  nonClinicalRooms: boolean;
  text: string;
  collapsible?: boolean;
}

const BookingTimes: FC<Props> = ({
  bookingSlots = [],
  openingTimes = {},
  clinicalRooms = false,
  nonClinicalRooms = false,
  text,
  collapsible = true,
}) => {
  const clinicalTable = () => (
    <TimeTable
      key="clinical"
      title={I18n.t('shared.clinical')}
      collapsible={collapsible}
      type="clinical"
    >
      <ClinicalTimes bookingSlots={bookingSlots} />
    </TimeTable>
  );

  const nonClinicalTable = () => (
    <TimeTable
      key="non-clinical"
      title={I18n.t('shared.non_clinical')}
      collapsible={collapsible}
      type="non-clinical"
    >
      <NonClinicalTimes openingTimes={openingTimes} />
    </TimeTable>
  );

  const renderTimeTables = () => [
    ...(clinicalRooms && bookingSlots.length > 0 ? [clinicalTable()] : []),
    ...(nonClinicalRooms && openingTimes ? [nonClinicalTable()] : []),
  ];

  const introText = () => {
    if (text) {
      return <p className="booking-times__text">{text}</p>;
    }
    return null;
  };

  return (
    <>
      <div className="booking-times">
        <h3 className="booking-times__heading">
          {I18n.t('rooms.booking_times')}
        </h3>
        {introText()}
        <div data-testid="bookingTimesTableContainer">{renderTimeTables()}</div>
      </div>
    </>
  );
};

export default BookingTimes;
